<div fxLayout="column" fxFill fxLayoutAlign="center center">
  <div [ngClass]="routeAnimationsElements" class="heading">
    <div style="font-family: Arial, Helvetica, sans-serif;">NOT FOUND</div>
  </div>
  <p style="font-family: Arial, Helvetica, sans-serif;" [ngClass]="routeAnimationsElements">
    Sorry! We can't seem to find the page you where looking for.
    <br>
    <button class="home-button" routerLink="/" mat-icon-button>
      <mat-icon aria-label="Home">home</mat-icon>
    </button> 
  </p>
  <img style="max-width:300px; width:100%;" src="assets/404.png" alt="Sample Image"  routerLink="/">
  <p [ngClass]="routeAnimationsElements">
   
  </p>
  <div [ngClass]="routeAnimationsElements">
    <div *ngIf="theme !== 'dark-theme'">
      <img class="sgit-logo" width="200px" src="assets/splash-small-light.png" />
    </div>
    <div *ngIf="theme === 'dark-theme'">
      <img class="sgit-logo" width="200px" src="assets/splash-small-dark.png" />
    </div>
  </div>
</div>